// Manageusers.tsx (updated)
import { useEffect, useState, ChangeEvent } from "react";
import { all_routes } from "../../../router/backendComponents/admin/all_routes";
import apiRequestCall from "../../../apiHelper/globalHelper";
import { parseValidationErrors } from "../../../apiHelper/validationHelper";
import Success from "../../../formHelper/success";
import apiFileRequestCall from "../../../apiHelper/filleHelper";

// Redux
import { useDispatch } from "react-redux";
import type { AppDispatch } from "../../../core/data/redux/store";
import { fetchProfile } from "../../../core/data/redux/profileDetails";

interface Profile {
  id?: number;
  profile_image?: File | string | null;
  name: string;
  last_name: string;
  email: string;
  user_name: string;
  password: string;
  confirm_password: string;
  role: string;
  created_at: string;
  branch: string;
}
let previewSrc: string | undefined;

const Manageusers = () => {
  const backendRoute = all_routes.backend;
  const [showMessage, setShowMessage] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [formError, setFormError] = useState<{ [key: string]: string }>({});
  const dispatch = useDispatch<AppDispatch>();

  const [formData, setFormData] = useState<Profile>({
    profile_image: null,
    name: "",
    last_name: "",
    email: "",
    user_name: "",
    password: "",
    confirm_password: "",
    role: "",
    created_at: "",
    branch: "",
  });

  if (formData?.profile_image) {
    if (formData.profile_image instanceof File) {
      previewSrc = URL.createObjectURL(formData.profile_image); // local upload
    } else {
      previewSrc = formData.profile_image as string; // full path from backend
    }
  } else {
    previewSrc = "assets/img/profile.png";
  }

  const getProfile = async () => {
    // You can either use the redux profile or fetch locally
    const result = await apiRequestCall("post", backendRoute.getProfile);
    if (result?.data?.code === 200) {
      const data = result.data.data;
      setFormData((prev) => ({
        ...prev,
        ...data,
        password: "",
        confirm_password: "",
        branch: data?.branch?.name ?? "",
        created_at: data?.created_at ?? "",
        role: data?.role?.name ?? "",
        name: data?.name ?? "",
        profile_image: data?.profile_image ?? null,
      }));
    }
  };

  useEffect(() => {
    dispatch(fetchProfile());
    getProfile();
  }, [dispatch]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value, files } = e.target;
    setFormError((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });

    if (files && files.length > 0) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleBasicInfoSubmit = async () => {
    const payload = new FormData();
    ["profile_image", "name", "last_name", "email"].forEach((key) => {
      const value = (formData as any)[key];
      if (value !== undefined && value !== null && value !== "") {
        payload.append(key, value as any);
      }
    });

    const result = await apiFileRequestCall(
      "post",
      backendRoute.updateProfile,
      {
        data: payload,
      }
    );

    if (result?.data?.code == 221) {
      setFormError(parseValidationErrors(result?.data?.errors));
      return;
    }

    if (result?.data?.code === 200) {
      dispatch(fetchProfile());
      setShowSuccess(true);
      setShowMessage(result?.data?.message);
      getProfile();
    }
  };

  const handlePasswordSubmit = async () => {
    const payload = {
      password: formData.password,
      confirm_password: formData.confirm_password,
    };

    const result = await apiRequestCall("post", backendRoute.updatePassWword, {
      data: payload,
    });
    if (result?.data?.code === 221) {
      setFormError(parseValidationErrors(result?.data?.errors));
      return;
    }
    if (result?.data?.code === 200) {
      setShowSuccess(true);
      setShowMessage(result?.data?.message);
      getProfile();
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* Page Header */}
        <div className="page-header">
          <div className="row">
            <div className="col">
              <h3 className="page-title">Profile Details</h3>
            </div>
          </div>
        </div>

        <div className="row">
          {/* Basic Info */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h6 className="card-title">Basic Info</h6>
              </div>
              <div className="card-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleBasicInfoSubmit();
                  }}
                >
                  <div className="row mb-2">
                    <label className="col-lg-3 form-label">Profile Image</label>
                    <div className="col-lg-9">
                      <div className="mb-0">
                        <div className="profile-upload d-flex align-items-center">
                          <div className="profile-upload-img avatar avatar-xxl border border-dashed rounded position-relative flex-shrink-0">
                            <span>
                              <i className="ti ti-photo"></i>
                            </span>
                            <img
                              id="ImgPreview"
                              src={previewSrc}
                              alt="img"
                              className="preview1 it"
                              style={{ maxWidth: 120, maxHeight: 120 }}
                            />
                          </div>
                          <div className="profile-upload-content ms-3">
                            <label className="d-inline-flex align-items-center position-relative btn btn-primary btn-sm mb-2">
                              <i className="ti ti-file-broken me-1"></i>Upload
                              File
                              <input
                                type="file"
                                id="imag"
                                name="profile_image"
                                onChange={handleChange}
                                className="input-img position-absolute w-100 h-100 opacity-0 top-0 end-0"
                              />
                            </label>
                            <p className="mb-0">
                              JPG, JPEG or PNG. Max size of 5MB
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label className="col-lg-3 form-label">First Name</label>
                    <div className="col-lg-9">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {formError.name && (
                        <div className="invalid-feedback d-block text-danger">
                          {formError.name}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label className="col-lg-3 form-label">Last Name</label>
                    <div className="col-lg-9">
                      <input
                        type="text"
                        name="last_name"
                        className="form-control"
                        value={formData.last_name}
                        onChange={handleChange}
                      />
                      {formError.last_name && (
                        <div className="invalid-feedback d-block text-danger">
                          {formError.last_name}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label className="col-lg-3 form-label">Email Address</label>
                    <div className="col-lg-9">
                      <input
                        readOnly
                        type="email"
                        name="email"
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label className="col-lg-3 form-label">Username</label>
                    <div className="col-lg-9">
                      <input
                        type="text"
                        name="user_name"
                        className="form-control"
                        value={formData.user_name}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="text-center">
                    <button type="submit" className="btn btn-soft-success">
                      Save Profile
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Change Password Section */}
          <div className="col-xl-6">
            <div className="card ">
              <div className="card-header">
                <h6 className="card-title">Change Password & Role</h6>
              </div>
              <div className="card-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handlePasswordSubmit();
                  }}
                >
                  <div className="row mb-4">
                    <label className="col-lg-3 form-label">
                      Enter Password
                    </label>
                    <div className="col-lg-9">
                      <input
                        type="password"
                        name="password"
                        className="form-control"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      {formError.password && (
                        <div className="invalid-feedback d-block text-danger">
                          {formError.password}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-4">
                    <label className="col-lg-3 form-label">
                      Confirm Password
                    </label>
                    <div className="col-lg-9">
                      <input
                        type="password"
                        name="confirm_password"
                        className="form-control"
                        value={formData.confirm_password}
                        onChange={handleChange}
                      />
                      {formError.confirm_password && (
                        <div className="invalid-feedback d-block text-danger">
                          {formError.confirm_password}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-4">
                    <label className="col-lg-3 form-label">Role</label>
                    <div className="col-lg-9">
                      <input
                        readOnly
                        type="text"
                        name="role"
                        className="form-control"
                        value={formData.role}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label className="col-lg-3 form-label">Join Date</label>
                    <div className="col-lg-9">
                      <input
                        readOnly
                        type="text"
                        name="created_at"
                        className="form-control"
                        value={formData.created_at}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row mb-5">
                    <label className="col-lg-3 form-label">Branch</label>
                    <div className="col-lg-9">
                      <input
                        type="text"
                        name="branch"
                        className="form-control"
                        value={formData.branch}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="text-center">
                    <button type="submit" className="btn btn-soft-success">
                      Update Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Success
        id="formatSuccessModal"
        title="User"
        message={showMessage}
        show={showSuccess}
        onClose={() => setShowSuccess(false)}
      />
    </div>
  );
};

export default Manageusers;
